export const ROTATION_TEXTS = [
  'Actionable Feedback',
  'Feedback you control',
  'Deep, Honest Feedback',
  'New Feedback Methods'
] as const;

export const ROTATION_INTERVAL = 5000; // 5 seconds
export const TRANSITION_DURATION = 500; // 0.5 seconds